module.exports = __webpack_public_path__ + "img/logo15.cc282163.png";